import { createAction, createReducer } from "redux-act";

import { reducerRegistry } from "../reducerRegistry";

export const reducerName = "layerCopyrights";

export type LayerCopyright = string;

export type LayerCopyrightsState = LayerCopyright[];

const initialState: LayerCopyrightsState = [];

export const reducer = createReducer({}, initialState);

const setLayerCopyrights = createAction<LayerCopyright>("layerCopyrights/set-layer-copyrights");

reducer.on(setLayerCopyrights, (state, layerCopyrightsState) => [...state, layerCopyrightsState]);

export const addLayerCopyright = (layerCopyright: LayerCopyright) => dispatch => {
  dispatch(setLayerCopyrights(layerCopyright));
};

reducerRegistry.register(reducerName, reducer);
